<template>
  <div class="components_warp">
        <div class="" v-if="name === 'test'">
          <div class="top-container">
          <div class="maze" >
            <header>
              <p >
                碰壁次数:<span id="pengzhuang">0</span>
              </p>
              <p>
                进入死胡同次数:<span id="sihutong">0</span>
              </p>
              <p style="opacity: 0">
                时间:<span id="Mazetime" >0</span>
              </p>
              <p style="opacity: 0">
                按键D次数:<span id="D">0</span>
              </p>
              <p style="opacity: 0">>
                按键K次数:<span id="K">0</span>
              </p>
            </header>
            <div class="canvasBj">
              <canvas width="447" height="447" id="canvas"></canvas>
            </div>
          </div>
        </div>
         
        </div>
        <div v-else>
          <div class="top-container">
          <div class="time" style="display:none"><i class="el-icon-time"></i> {{ min }}:{{ sec }}</div>
          <div class="maze" >
            <header>
              <p >
                碰壁次数:<span id="pengzhuang">0</span>
              </p>
              <p>
                进入死胡同次数:<span id="sihutong">0</span>
              </p>
              <p style="opacity: 0">
                时间:<span id="Mazetime" >0</span>
              </p>
              <p style="opacity: 0">
                按键D次数:<span id="D">0</span>
              </p>
              <p style="opacity: 0">>
                按键K次数:<span id="K">0</span>
              </p>
            </header>
            <div class="canvasBj">
              <canvas width="447" height="447" id="canvas"></canvas>
            </div>
          </div>
        </div>
         
        </div>
        <div class="mask" v-show="isHideBtn">
            <div class="mask_msg">
                  <div class="msg_text">
                    <p>
                      如果你在此测验的作答上存在困难，可选择跳过此部分，点击“进入下一个测验”即可。
                      
                    </p>
                    <p style="margin-top:30px">如果你不想跳过，请忽略此提示继续作答。</p>
                  </div>
                  <div class="btn_warp">
         
                  <span></span>
                  <button @click="nextClick()">进入下一个测验</button>
                  <span
                    ></span
                  >
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      min: "",
      sec: "",
      end: "",
      startTime: "",
      endTime: "",
      clearTime: "",
      tempTime: "",
      curTempTime: "",

      curIndex: 0,
      topics: [],
      letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      name: this.$route.query.name,
      url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp101'}},
      isHideBtn:false
    };
  },
  created(){
    
  },
  mounted(){
      

        
        $('.test_menu .item').eq(6).addClass('item_2');
        let _this=this
     if(this.name=='test'){
       sessionStorage.setItem("kongTest91",1)
         new Maze({

             type:'simple',
             el:'#canvas',
             time:'#Mazetime',
             wallCollsion:'#pengzhuang',
             deadEnd:'#sihutong',
             D:'#D',
             K:'#K',
             vue:_this,
         })
     }else{
        this.startTime = new Date().getTime();
        this.end = Date.parse(new Date()) + 600000; // 截止时间为7分钟（1min为60000ms,）
       this.countdown()
         new Maze({
             type:'complex',
             el:'#canvas',
             time:'#Mazetime',
             wallCollsion:'#pengzhuang',
             deadEnd:'#sihutong',
             D:'#D',
             K:'#K',
             vue:_this
         })
    }
  },
  destroyed() {
    clearTimeout(this.clearTime); // 清除
  },
  methods: {
      nextClick(){
        var that = this
        this.saveNode(2,101,()=>{
          
          this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.stydnlAdd2}`, {
                testId:sessionStorage.getItem('testId'),
                /// time: times,
                time: 600000,// number	是	测试总时间		5000
                answers:{
                  deadNums:30,
                  diyNums:40
                },
                // dead_nums: Number(this.deadEnd.innerHTML),// number	进入死胡同次数		590
                // diy_nums: Number(this.wallCollision.innerHTML),// 	number	是	碰壁次数
              }, {
                headers: {
                  "token": sessionStorage.getItem('token')
                }
              },
              {
                emulateJSON: true
              }).then(
              function (res) {
                // 请求成功的结果
               if(res.data.code==2000){
                 that.$router.push({
                   path: "/careerevalution/success",
                   query: {
                     type: "answer",
                     url:that.url,
                   },
                 });
                }else{
                  this.$message({
                    message: res.data.msg,
                    type: 'error'
                  });
                }
              },
              function (res) {
                console.log('接口响应失败，请联系网站管理人员');
              }
          );
        })
      },
     countdown() {
      const end = this.end;
      const now = Date.parse(new Date());
      // console.log(now);
      const msec = end - now;
      // console.log(msec);
      if (msec < 0) return;

      //  let day = parseInt(msec / 1000 / 60 / 60 / 24)
      //  let hr = parseInt(msec / 1000 / 60 / 60 % 24)
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      //  this.day = day
      //  this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      const that = this;
      if (min == 0 && sec == 0) {
        //倒计时结束
         this.isHideBtn = true
        // if (min == 0 && sec == 0) {
        //   this.saveNode(2,101,()=>{
        //   this.myMaze.submitMaze()
        // })
          // this.$router.push({
          //   path: "/careerevalution/home",
          //   query: {
          //     name: "znsp",
          //     part:'znsp101'
          //   },
          // // });
          // console.log("倒计时结束");
        }
        this.clearTime = setTimeout(function () {
         
          that.countdown();
        }, 1000);
      // }
    },
  },
};
</script>

<style scoped>
.mask_msg{
    width: 250px;
    height: 200px;
    position: absolute;
    right: 6%;
    top: 16%;
    margin-left: -100px;
    margin-top: -100px;
    padding: 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.msg_text{
  color: red;
  font-size: 20px;
      margin-top: 160px;
}
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
header > p{
    color: red;
    font-size: 20px;
    line-height: 40px;
    text-indent: 20px;
}
.canvasBj{
      position: absolute;
    padding: 20px;
    background: #fff;
    overflow: hidden;
    top: 50%;
    left: 50%;
    margin-left: -234px;
    margin-top: -234px;
}
.btn_warp{
  /* position: relative;
    top: 360px; */
}
.mask {
	/* position: fixed;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, .3); */
}
.time {
  position: absolute;
  top: 40px;
  right: 40px;
  color: red;
}

</style>